module.exports = __webpack_public_path__ + "media/images/icons/outlined/ci-circle-301733649714cf5219af8a61db32cf14.svg";